/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'
import { signImageUploadDataCollectionSchema } from './SignImageUploadDataCollectionSchema'
import { signImageUploadDataMimeTypeSchema } from './SignImageUploadDataMimeTypeSchema'

export const signImageUploadDataSchema = z.object({
	id: z.string().uuid().nullable().optional(),
	filename: z.string(),
	mimeType: signImageUploadDataMimeTypeSchema,
	size: z.number(),
	collection: signImageUploadDataCollectionSchema,
	meta: z.array(z.string()).nullable().optional(),
})

export type SignImageUploadDataSchema = z.infer<typeof signImageUploadDataSchema>
